export type Language = 'es' | 'en';

export const translations: Record<Language, Record<string, string>> = {
  es: {
    // Navigation
    'nav.categories': 'Categorías',
    'nav.favorites': 'Favoritos',
    'nav.login': 'Iniciar Sesión',
    'nav.signup': 'Registrarse',
    'nav.sell': 'Vender',
    'nav.myAccount': 'Mi Cuenta',
    'nav.signOut': 'Cerrar Sesión',
    'nav.myOrders': 'Mis Pedidos',
    'nav.settings': 'Configuración',
    'nav.cart': 'Carrito',
    'nav.search': 'Buscar productos...',
    
    // Hero Section
    'hero.title': 'La Feria en Línea de',
    'hero.titleHighlight': 'los Emprendedores Ticos',
    'hero.subtitle': 'Productos únicos hechos en Costa Rica',
    'hero.hashtag': '#shoplocal',
    'hero.subtitleExtra': 'Apoyá lo nuestro. Comprá local.',
    'hero.exploreProducts': 'Explorar Productos',
    'hero.sellOnTicoMarket': 'Vender en TicoMarket',
    
    // Products Page
    'products.title': 'Productos Artesanales',
    'products.search': 'Buscar productos...',
    'products.filters': 'Filtros',
    'products.clearAll': 'Limpiar todo',
    'products.viewProducts': 'Ver {count} productos',
    'products.noProducts': 'No encontramos productos',
    'products.noProductsDescription': 'Intenta con otros filtros o términos de búsqueda',
    'products.sortBy': 'Ordenar por',
    'products.newest': 'Más recientes',
    'products.priceLowHigh': 'Precio: menor a mayor',
    'products.priceHighLow': 'Precio: mayor a menor',
    'products.featured': 'Destacados',
    
    // Product Card
    'product.addToCart': 'Añadir al carrito',
    'product.printedProduct': 'Producto impreso',
    'product.digitalOnly': 'Solo archivo digital',
    'product.digital': 'Digital',
    'product.freeShipping': 'Envío gratis',
    'product.discount': '{percent}% descuento',
    
    // Product Detail
    'productDetail.addToCart': 'Añadir al carrito',
    'productDetail.buyNow': 'Comprar ahora',
    'productDetail.description': 'Descripción',
    'productDetail.shipping': 'Envío',
    'productDetail.shippingInfo': 'Información de envío',
    'productDetail.sellerInfo': 'Información del vendedor',
    'productDetail.viewStore': 'Ver tienda',
    'productDetail.contactSeller': 'Contactar vendedor',
    'productDetail.digitalDelivery': 'Entrega digital inmediata',
    'productDetail.printedDelivery': 'Envío a domicilio',
    'productDetail.usShippingOnly': 'Solo envío a Estados Unidos',
    
    // Cart
    'cart.title': 'Tu carrito',
    'cart.empty': 'Tu carrito está vacío',
    'cart.emptyDescription': 'Explora nuestros productos y encuentra algo que te guste',
    'cart.continueShopping': 'Continuar comprando',
    'cart.subtotal': 'Subtotal',
    'cart.shipping': 'Envío',
    'cart.total': 'Total',
    'cart.proceedToCheckout': 'Proceder al pago',
    'cart.remove': 'Eliminar',
    
    // Checkout
    'checkout.title': 'Finalizar compra',
    'checkout.shippingAddress': 'Dirección de envío',
    'checkout.paymentMethod': 'Método de pago',
    'checkout.orderSummary': 'Resumen del pedido',
    'checkout.placeOrder': 'Realizar pedido',
    'checkout.processing': 'Procesando...',
    
    // Footer
    'footer.buy': 'Comprar',
    'footer.sell': 'Vender',
    'footer.contact': 'Contacto',
    'footer.createAccount': 'Crear cuenta',
    'footer.giftRegistries': 'Listas de regalos',
    'footer.faq': 'Preguntas Frecuentes',
    'footer.consumerProtection': 'Protección al Consumidor',
    'footer.startSelling': 'Comenzar a vender',
    'footer.fees': 'Tarifas',
    'footer.sellerHandbook': 'Manual del Vendedor',
    'footer.merchantProtection': 'Protección al Comercio',
    'footer.sendSupportTicket': 'Enviar ticket de soporte',
    'footer.rights': 'Todos los derechos reservados.',
    'footer.terms': 'Términos',
    'footer.privacy': 'Privacidad',
    'footer.copyright': 'Derechos de Autor',
    
    // Common
    'common.loading': 'Cargando...',
    'common.error': 'Error',
    'common.retry': 'Reintentar',
    'common.cancel': 'Cancelar',
    'common.save': 'Guardar',
    'common.delete': 'Eliminar',
    'common.edit': 'Editar',
    'common.viewAll': 'Ver todos',
    'common.back': 'Volver',
    'common.next': 'Siguiente',
    'common.previous': 'Anterior',
    
    // Collections
    'collections.title': 'Colecciones',
    'collections.viewAll': 'Ver todas',
    
    // Featured
    'featured.title': 'Productos Destacados',
    'featured.viewAll': 'Ver todos',
  },
  
  en: {
    // Navigation
    'nav.categories': 'Categories',
    'nav.favorites': 'Favorites',
    'nav.login': 'Sign In',
    'nav.signup': 'Sign Up',
    'nav.sell': 'Sell',
    'nav.myAccount': 'My Account',
    'nav.signOut': 'Sign Out',
    'nav.myOrders': 'My Orders',
    'nav.settings': 'Settings',
    'nav.cart': 'Cart',
    'nav.search': 'Search products...',
    
    // Hero Section
    'hero.title': 'The Online Fair for',
    'hero.titleHighlight': 'Creative Entrepreneurs',
    'hero.subtitle': 'Unique products made with passion',
    'hero.hashtag': '#shopunique',
    'hero.subtitleExtra': 'Discover unique designs. Ship to USA.',
    'hero.exploreProducts': 'Explore Products',
    'hero.sellOnTicoMarket': 'Start Selling',
    
    // Products Page
    'products.title': 'Print-on-Demand Products',
    'products.search': 'Search products...',
    'products.filters': 'Filters',
    'products.clearAll': 'Clear all',
    'products.viewProducts': 'View {count} products',
    'products.noProducts': 'No products found',
    'products.noProductsDescription': 'Try different filters or search terms',
    'products.sortBy': 'Sort by',
    'products.newest': 'Newest',
    'products.priceLowHigh': 'Price: low to high',
    'products.priceHighLow': 'Price: high to low',
    'products.featured': 'Featured',
    
    // Product Card
    'product.addToCart': 'Add to cart',
    'product.printedProduct': 'Printed product',
    'product.digitalOnly': 'Digital file only',
    'product.digital': 'Digital',
    'product.freeShipping': 'Free shipping',
    'product.discount': '{percent}% off',
    
    // Product Detail
    'productDetail.addToCart': 'Add to cart',
    'productDetail.buyNow': 'Buy now',
    'productDetail.description': 'Description',
    'productDetail.shipping': 'Shipping',
    'productDetail.shippingInfo': 'Shipping information',
    'productDetail.sellerInfo': 'Seller information',
    'productDetail.viewStore': 'View store',
    'productDetail.contactSeller': 'Contact seller',
    'productDetail.digitalDelivery': 'Instant digital delivery',
    'productDetail.printedDelivery': 'Home delivery',
    'productDetail.usShippingOnly': 'US shipping only',
    
    // Cart
    'cart.title': 'Your cart',
    'cart.empty': 'Your cart is empty',
    'cart.emptyDescription': 'Explore our products and find something you like',
    'cart.continueShopping': 'Continue shopping',
    'cart.subtotal': 'Subtotal',
    'cart.shipping': 'Shipping',
    'cart.total': 'Total',
    'cart.proceedToCheckout': 'Proceed to checkout',
    'cart.remove': 'Remove',
    
    // Checkout
    'checkout.title': 'Checkout',
    'checkout.shippingAddress': 'Shipping address',
    'checkout.paymentMethod': 'Payment method',
    'checkout.orderSummary': 'Order summary',
    'checkout.placeOrder': 'Place order',
    'checkout.processing': 'Processing...',
    
    // Footer
    'footer.buy': 'Buy',
    'footer.sell': 'Sell',
    'footer.contact': 'Contact',
    'footer.createAccount': 'Create account',
    'footer.giftRegistries': 'Gift registries',
    'footer.faq': 'FAQ',
    'footer.consumerProtection': 'Consumer Protection',
    'footer.startSelling': 'Start selling',
    'footer.fees': 'Fees',
    'footer.sellerHandbook': 'Seller Handbook',
    'footer.merchantProtection': 'Merchant Protection',
    'footer.sendSupportTicket': 'Send support ticket',
    'footer.rights': 'All rights reserved.',
    'footer.terms': 'Terms',
    'footer.privacy': 'Privacy',
    'footer.copyright': 'Copyright',
    
    // Common
    'common.loading': 'Loading...',
    'common.error': 'Error',
    'common.retry': 'Retry',
    'common.cancel': 'Cancel',
    'common.save': 'Save',
    'common.delete': 'Delete',
    'common.edit': 'Edit',
    'common.viewAll': 'View all',
    'common.back': 'Back',
    'common.next': 'Next',
    'common.previous': 'Previous',
    
    // Collections
    'collections.title': 'Collections',
    'collections.viewAll': 'View all',
    
    // Featured
    'featured.title': 'Featured Products',
    'featured.viewAll': 'View all',
  }
};

export const getTranslation = (language: Language, key: string, params?: Record<string, string | number>): string => {
  let text = translations[language][key] || translations['es'][key] || key;
  
  if (params) {
    Object.entries(params).forEach(([paramKey, value]) => {
      text = text.replace(`{${paramKey}}`, String(value));
    });
  }
  
  return text;
};
